import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";

const ProductCard = ({ product, onEdit, onDelete, onView }) => {
  return (
   <Card
  sx={{
    borderRadius: 3,
    boxShadow: 3,
    height: "380",
    display: "flex",
    flexDirection: "column",
    transition: "0.3s",
    "&:hover": { transform: "translateY(-5px)" },
  }}
>
      <CardMedia
  component="img"
  height="220"
  image={product.image}
  alt={product.name}
/>

      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6">{product.name}</Typography>
        <Typography color="text.secondary">
          ₹ {product.price}
        </Typography>

        <Box mt={2} display="flex" justifyContent="space-between">
          <IconButton color="primary" onClick={() => onView(product)}>
            <FaEye />
          </IconButton>

          <IconButton color="success" onClick={() => onEdit(product)}>
            <FaEdit />
          </IconButton>

          <IconButton color="error" onClick={() => onDelete(product._id)}>
            <FaTrash />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
